import { Col, Row } from 'react-bootstrap'
import './Footer.css'

const Footer = () => {

    return (
        <footer>
            <p> © 2022 Pooeblo | Guille Ávila & Inés García</p>
        </footer>
    )
}

export default Footer